import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Enteral Info</h3>
				<hr />
				<p>Does the patient have a BMI under 22 and have they experienced a 5% unintentional weight loss over the previous six months?</p>
				<div className="toggle">
					<div className={this.props.data.BMIUnder22And5Loss == 'Yes' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('BMIUnder22And5Loss', 'Yes') }}>Yes</div>
					<div className={this.props.data.BMIUnder22And5Loss == 'No' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('BMIUnder22And5Loss', 'No') }}>No</div>
				</div>
				<br />

				{this.props.data.BMIUnder22And5Loss == 'No' ?
					<div>
						<p>Does the patient require total nutritional support and have a permanent structural limitation where tube feeding is medically contraindicated?</p>
						<div className="toggle">
							<div className={this.props.data.StructuralLimitation == 'Yes' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('StructuralLimitation', 'Yes') }}>Yes</div>
							<div className={this.props.data.StructuralLimitation == 'No' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('StructuralLimitation', 'No') }}>No</div>
						</div>
						<br />
					</div> : ''}

				<div className="button" onClick={() => this.props.navigate(this.props.data.BMIUnder22And5Loss == 'Yes' || this.props.data.StructuralLimitation == 'Yes' ? 'R13' : 'R14B')}>Continue</div>
			</div>
		);

	}
}